import { Chip } from "@mui/material";

export default function ChipSys({...props}){
    return (
        <Chip sx={{width: '80px'}} {...props} />
    )
}